const Home = () =>
	import(/* webpackChunkName: "home" */ "./components/Home.vue");
const Report = () =>
	import(/* webpackChunkName: "report" */ "./views/Report.vue");
const Maintenance = () =>
	import(/* webpackChunkName: "maintenance" */ "./views/Maintenance.vue");
const MaintDashboard = () =>
	import(
		/* webpackChunkName: "maintenance-dashboard" */ "./components/maintenance/Dashboard.vue"
	);
const MaintSchedule = () =>
	import(
		/* webpackChunkName: "maintenance-schedule" */ "./components/maintenance/Schedule.vue"
	);
const MaintService = () =>
	import(
		/* webpackChunkName: "maintenance-service" */ "./components/maintenance/Service.vue"
	);
const MaintErrorCode = () =>
	import(
		/* webpackChunkName: "maintenance-errorcode" */ "./components/maintenance/ErrorCode.vue"
	);
const Admin = () => import(/* webpackChunkName: "admin" */ "./views/Admin.vue");
const AdminUsers = () =>
	import(/* webpackChunkName: "admin-users" */ "./components/admin/Users.vue");
const AdminDevices = () =>
	import(
		/* webpackChunkName: "admin-devices" */ "./components/admin/Devices.vue"
	);
const AdminDrivers = () =>
	import(
		/* webpackChunkName: "admin-drivers" */ "./components/admin/Drivers.vue"
	);
const AdminLinksTrackings = () =>
	import(/* webpackChunkName: "admin-links" */ "./components/admin/Links.vue");
const AdminRoles = () =>
	import(/* webpackChunkName: "admin-roles" */ "./components/admin/Roles.vue");
const AdminIntegrations = () =>
	import(
		/* webpackChunkName: "admin-integrations" */ "./components/admin/Integrations.vue"
	);
const AdminAlerts = () =>
	import(
		/* webpackChunkName: "admin-alarms" */ "./components/admin/Alarms.vue"
	);
const AdminAlertsDashboard = () =>
	import(
		/* webpackChunkName: "admin-alarms-dashboard" */ "./components/admin/AlarmsDashboard.vue"
	);
const AdminAlertsDevice = () =>
	import(
		/* webpackChunkName: "admin-alarms-devices" */ "./components/admin/AlarmsDevice.vue"
	);
const AdminAlertsGeo = () =>
	import(
		/* webpackChunkName: "admin-alarms-geofences" */ "./components/admin/AlarmsGeofences.vue"
	);
const AdminAlertsConfig = () =>
	import(
		/* webpackChunkName: "admin-alarms-configuration" */ "./components/admin/AlarmsConfig.vue"
	);
const AdminPerformance = () =>
	import(
		/* webpackChunkName: "admin-performance" */ "./components/admin/Performance.vue"
	);
const Geofence = () =>
	import(/* webpackChunkName: "geofence" */ "./views/Geofence.vue");
const Routes = () =>
	import(/* webpackChunkName: "routes" */ "./views/Routes.vue");
const DeckFindme = () =>
	import(/* webpackChunkName: "deck-findme" */ "./views/deckgl/Findme.vue");
const Denied = () =>
	import(/* webpackChunkName: "error" */ "./views/Denied.vue");
const Executive = () =>
	import(/* webpackChunkName: "executive" */ "./views/Executive.vue");
const DeckRealtime = () =>
	import(/* webpackChunkName: "deck-realtime" */ "./views/deckgl/Realtime.vue");
const DeckHistory = () =>
	import(/* webpackChunkName: "deck-history" */ "./views/deckgl/History.vue");
const Cameras = () =>
	import(/* webpackChunkName: "videos-new" */ "./views/Cameras.vue");
const AdminAlarmsAudios = () =>
	import(
		/* webpackChunkName: "admin-alarms-audios" */ "./components/admin/AlarmsAudios.vue"
	);
const AdminGroups = () =>
	import(
		/* webpackChunkName: "admin-groups" */ "./components/admin/Groups.vue"
	);
const DynamicReport = () =>
	import(/* webpackChunkName: "dynamic-report" */ "./views/deckgl/Dynamic.vue");
const LiveCamera = () =>
	import(/* webpackChunkName: "live-camera" */ "./views/LiveCamera.vue");
const Users = () => import(/* webpackChunkName: "users" */ "./views/Users.vue");
const UsersLogin = () =>
	import(
		/* webpackChunkName: "userslogin" */ "../src/components/users/Login.vue"
	);
const PrivacyPolicies = () => import("./views/PrivacyPolicies.vue")
const RedirectPage = () => import("./views/RedirectPage.vue")

import { AuthService } from "./utils/authService";
import { TokenService } from "./utils/storageService";

export const routes = [
	{
		path: "*",
		// redirect: "/",
		beforeEnter: (to, from, next) => {
			if (TokenService.getToken()) {
				next("/realtime");
			} else {
				next("/login");
			}
		},
	},
	{
		path: "",
		name: "home",
		component: RedirectPage,
		meta: {
			auth: false,
		},
	},
	{
		path: "/login",
		name: "login",
		component: Home,
		meta: {
			auth: false,
		},
	},
	{
		path: "/realtime",
		name: "realtime",
		component: DeckRealtime,
		meta: {
			auth: true,
		},
		beforeEnter: (to, from, next) => {
			if (AuthService.isRoot()) {
				next();
			} else {
				if (AuthService.module("realtime")) {
					next();
				} else {
					next("/denied");
				}
			}
		},
	},
	{
		path: "/history",
		name: "history",
		component: DeckHistory,
		meta: {
			auth: true,
		},
		beforeEnter: (to, from, next) => {
			if (AuthService.isRoot()) {
				next();
			} else {
				if (AuthService.module("history")) {
					next();
				} else {
					next("/denied");
				}
			}
		},
	},
	{
		path: "/reports",
		name: "report",
		meta: {
			auth: true,
		},
		component: Report,
		beforeEnter: (to, from, next) => {
			if (AuthService.isRoot()) {
				next();
			} else {
				if (AuthService.module("reports")) {
					next();
				} else {
					next("/denied");
				}
			}
		},
	},
	{
		path: "/geofences",
		name: "geofences",
		component: Geofence,
		meta: {
			auth: true,
		},
		beforeEnter: (to, from, next) => {
			if (AuthService.isRoot()) {
				next();
			} else {
				if (AuthService.module("geofences")) {
					next();
				} else {
					next("/denied");
				}
			}
		},
	},
	// {
	// 	path: "/maintenance",
	// 	// name: "maintenance",
	// 	component: Maintenance,
	// 	meta: {
	// 		auth: true,
	// 	},
	// 	children: [
	// 		{
	// 			path: "",
	// 			name: "maintenances",
	// 			component: MaintDashboard,
	// 		},
	// 		{
	// 			path: "schedule/:id?",
	// 			name: "maintenanceSchedules",
	// 			component: MaintSchedule,
	// 			props: true,
	// 		},
	// 		{
	// 			path: "service",
	// 			name: "maintenanceLogServices",
	// 			component: MaintService,
	// 		},
	// 		{
	// 			path: "errorcode",
	// 			name: "maintenanceDeviceErrorsCode",
	// 			component: MaintErrorCode,
	// 		},
	// 	],
	// 	beforeEnter: (to, from, next) => {
	// 		// console.log(to);
	// 		// console.log(from);
	// 		if (AuthService.isRoot()) {
	// 			// console.log('Is root!');
	// 			next();
	// 		} else {
	// 			// console.log('Is NOT root!');
	// 			if (AuthService.submodule("maintenance", "maintenances", to.query.rd)) {
	// 				// console.log('Is submodule!');
	// 				next();
	// 			} else {
	// 				// console.log('Is NOT submodule!');
	// 				let redirect = AuthService.redirect("maintenance");
	// 				// console.log('redirect:', redirect);

	// 				if (redirect === false) {
	// 					// console.log('redirect is false');
	// 					next("/denied");
	// 				} else if (redirect && to.query.rd) {
	// 					// console.log('redirect && to.query.rd');
	// 					next();
	// 				} else {
	// 					// console.log('redirect is true or something');
	// 					next({
	// 						name: redirect,
	// 						query: {
	// 							rd: true,
	// 						},
	// 					});
	// 				}
	// 			}
	// 		}
	// 	},
	// },
	// {
	// 	path: "/admin",
	// 	component: Admin,
	// 	meta: {
	// 		auth: true,
	// 	},
	// 	children: [
	// 		{
	// 			path: "",
	// 			name: "adminDevices",
	// 			component: AdminDevices,
	// 			meta: {
	// 				module: "Devices",
	// 			},
	// 		},
	// 		{
	// 			path: "users",
	// 			name: "adminUsers",
	// 			component: AdminUsers,
	// 			meta: {
	// 				module: "Users",
	// 			},
	// 		},
	// 		{
	// 			path: "roles",
	// 			name: "adminRoles",
	// 			component: AdminRoles,
	// 			meta: {
	// 				module: "Roles",
	// 			},
	// 		},
	// 		{
	// 			path: "groups",
	// 			name: "adminGroups",
	// 			component: AdminGroups,
	// 			meta: {
	// 				module: "Groups",
	// 			},
	// 		},
	// 		{
	// 			path: "drivers",
	// 			name: "adminDrivers",
	// 			component: AdminDrivers,
	// 			meta: {
	// 				module: "Drivers",
	// 			},
	// 		},
	// 		{
	// 			path: "performance",
	// 			name: "adminPerformance",
	// 			component: AdminPerformance,
	// 			meta: {
	// 				module: "Performance",
	// 			},
	// 		},
	// 		{
	// 			path: "links",
	// 			name: "adminLinksTrackings",
	// 			component: AdminLinksTrackings,
	// 			meta: {
	// 				module: "LinkTrackings",
	// 			},
	// 		},
	// 		{
	// 			path: "alarms",
	// 			// name: 'adminAlarms',
	// 			component: AdminAlerts,
	// 			meta: {
	// 				module: "Alerts",
	// 			},
	// 			children: [
	// 				{
	// 					path: "",
	// 					name: "adminAlerts",
	// 					component: AdminAlertsDashboard,
	// 				},
	// 				{
	// 					path: "device/:id?",
	// 					name: "adminAlertsDevices",
	// 					component: AdminAlertsDevice,
	// 					props: true,
	// 				},
	// 				{
	// 					path: "geofence/:id?",
	// 					name: "adminAlertsGeofences",
	// 					component: AdminAlertsGeo,
	// 					props: true,
	// 				},
	// 				{
	// 					path: "configuration",
	// 					name: "adminAlertConfiguration",
	// 					component: AdminAlertsConfig,
	// 				},
	// 				{
	// 					path: "audios",
	// 					name: "adminAlarmsAudios",
	// 					component: AdminAlarmsAudios,
	// 				},
	// 			],
	// 		},
	// 		{
	// 			path: "integrations",
	// 			name: "adminIntegrations",
	// 			component: AdminIntegrations,
	// 			meta: {
	// 				module: "Integrations",
	// 			},
	// 		},
	// 	],
	// 	beforeEnter: (to, from, next) => {
	// 		if (AuthService.isRoot()) {
	// 			next();
	// 		} else {
	// 			if (AuthService.submodule("admin", "devices", to.query.rd)) {
	// 				next();
	// 			} else {
	// 				let redirect = AuthService.redirect("admin");

	// 				if (redirect === false) {
	// 					next("/denied");
	// 				} else if (redirect && to.query.rd) {
	// 					next();
	// 				} else {
	// 					next({
	// 						name: redirect,
	// 						query: {
	// 							rd: true,
	// 						},
	// 					});
	// 				}
	// 			}
	// 		}
	// 	},
	// },
	// {
	// 	path: "/routes",
	// 	name: "routes",
	// 	component: Routes,
	// 	meta: {
	// 		auth: true,
	// 	},
	// 	beforeEnter: (to, from, next) => {
	// 		const { services } = TokenService.getSession();

	// 		if (AuthService.isRoot()) {
	// 			next();
	// 		} else {
	// 			if (AuthService.module("routes") && services.route) {
	// 				next();
	// 			} else {
	// 				next("/denied");
	// 			}
	// 		}
	// 	},
	// },
	// {
	// 	path: "/executive",
	// 	name: "executive",
	// 	component: Executive,
	// 	meta: {
	// 		auth: true,
	// 	},
	// },
	{
		path: "/findme",
		name: "findme",
		component: DeckFindme,
		meta: {
			auth: false,
		},
		props: true,
	},
	{
		path: "/denied",
		name: "denied",
		component: Denied,
		meta: {
			auth: false,
		},
		props: true,
	},
	{
		path: "/cameras",
		name: "cameras",
		component: Cameras,
		meta: {
			auth: false,
		},
		props: true,
	},
	{
		path: "/cameras/live",
		name: "liveCamera",
		component: LiveCamera,
		meta: {
			auth: true,
		},
		beforeEnter: (to, from, next) => {
			if (AuthService.isRoot()) {
				next();
			} else {
				if (TokenService.getSession().services.live) {
					next();
				} else {
					next("/cameras");
				}
			}
		},
	},
	{
		path: "/dynamic-report",
		name: "dynamic",
		component: DynamicReport,
		meta: {
			auth: false,
		},
		props: true,
	},
	{
		path: "/users",
		component: Users,
		meta: {
			auth: false,
		},
	},
	{
		path: "/privacy-policies",
		component: PrivacyPolicies,
	},
];
